import { dayWidth, weekWidth, monthWidth } from "./../constants";

export const getCanvasWidth = (zoom: number, cols: number) => {
  //const wrapperWidth = document.getElementById(outsideWrapperId)?.clientWidth || 0;
  //const width = (wrapperWidth - leftColumnWidth) * screenWidthMultiplier;
   let width;
   switch (zoom) {
    case 1:
      width = cols * dayWidth + 1; // +1 para mostrar o pixel da linha
      break;
    case 4:
      width = cols * monthWidth + 1;
      break;
    default:
      width = (cols * weekWidth) + weekWidth + 1; //corrige bug da ultima semana não aparecendo
      break;
   }
   
  return width;
};
